<template>
    <div class="claims">
        <z-lead v-html="text.lead" />
        <div class="claims__content">
            <div
                class="row"
                v-if="!loading"
            >
                <div class="col-default-12">
                    <form
                        @submit.prevent="submit"
                        id="feedbackForm"
                        name="feedbackForm"
                        class="claims__form"
                    >
                        <div class="row">
                            <div class="col-default-12">
                                <z-input
                                    name="companies"
                                    ref="companies"
                                    v-model="params.companies.value"
                                    required
                                    :placeholder="params.companies.placeholder"
                                ></z-input>
                            </div>
                            <div class="col-default-6 col-v-tablet-12">
                                <z-input
                                    name="user"
                                    ref="user"
                                    v-model="params.user.value"
                                    required
                                    :placeholder="params.user.placeholder"
                                ></z-input>
                            </div>
                            <div class="col-default-6 col-v-tablet-12">
                                <z-input
                                    name="email"
                                    type="email"
                                    ref="email"
                                    v-model="params.email.value"
                                    required
                                    :placeholder="params.email.placeholder"
                                ></z-input>
                            </div>
                            <div class="col-default-6 col-v-tablet-12">
                                <z-input
                                    name="phone"
                                    type="tel"
                                    ref="phone"
                                    v-model="params.phone.value"
                                    required
                                    :placeholder="params.phone.placeholder"
                                ></z-input>
                            </div>
                            <div class="col-default-6 col-v-tablet-12">
                                <z-input
                                    name="product"
                                    ref="product"
                                    v-model="params.product.value"
                                    required
                                    :placeholder="params.product.placeholder"
                                ></z-input>
                            </div>
                            <div class="col-default-6 col-v-tablet-12">
                                <z-input
                                    name="volume"
                                    ref="volume"
                                    v-model="params.volume.value"
                                    required
                                    :placeholder="params.volume.placeholder"
                                ></z-input>
                            </div>
                            <div class="col-default-6 col-v-tablet-12">
                                <z-input
                                    name="transport"
                                    ref="transport"
                                    v-model="params.transport.value"
                                    required
                                    :placeholder="params.transport.placeholder"
                                ></z-input>
                            </div>
                            <div v-if="filters.type.options" class="col-default-6 col-mobile-12">
                                <z-select
                                    name="typeSelect"
                                    ref="typeSelect"
                                    required
                                    v-model="params.type.value"
                                    :data="filters.type.options"
                                    :placeholder="params.type.placeholder"
                                ></z-select>
                            </div>
                            <div v-if="filters.managers.options" class="col-default-6 col-mobile-12">
                                <z-select
                                    name="managersSelect"
                                    ref="managersSelect"
                                    required
                                    v-model="params.managers.value"
                                    :data="filters.managers.options"
                                    :placeholder="params.managers.placeholder"
                                ></z-select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-default-12">
                                <z-textarea
                                    name="message"
                                    v-model="params.text.value"
                                    :placeholder="params.text.placeholder"
                                    maxlength="600"
                                ></z-textarea>
                            </div>
                        </div>
                        <div class="row">
                            <div
                                class="col-default-12 row"
                                v-for="item in fileForm"
                                :key="item.id"
                            >
                                <div class="col-default-4 col-tablet-12 u-margin--no-important">
                                    <div class="claims__input-title" v-html="item.name"></div>
                                </div>
                                <div class="col-default-4 col-tablet-12 u-margin--no-important">
                                    <div class="claims__file">
                                        <label
                                            :for="item.id"
                                            class="claims__attach"
                                        >
                                            <z-icon name="attach" height="24" width="24"></z-icon><span v-html="item.id in showError ? text.file : text.fileNone"></span>
                                            <input
                                                multiple
                                                type="file"
                                                @change="createFile($event, item.id)"
                                                :id="item.id"
                                                :name="item.id"
                                                :ref="`fileInput${item.id}`"
                                                :accept="acceptFiles"
                                            />
                                        </label>
                                        <label
                                            class="claims__attach--error"
                                            for="feedbackFormFile"
                                            id="feedbackFormFile-error"
                                            v-if="!files[item.id].length && showError[item.id]"
                                            >{{text.required}}
                                        </label>
                                    </div>
                                </div>
                                <div
                                    v-if="files[item.id].length"
                                    class="col-default-5 col-default-offset-4 col-tablet-12 col-tablet-offset-0">
                                    <div
                                        :data-id="item.id"
                                        class="claims__filelist"
                                        v-for="(file, index) in files[item.id]"
                                        :key="index"
                                    >
                                        <z-icon :name="`file/${file.name.split('.').pop()}`" width="30" height="30"></z-icon>
                                        <div class="claims__filelist-inner">
                                            <span class="claims__filelist-name">{{buildName(file.name)}}</span>
                                            <div class="claims__filelist-size">{{getFileDesc(file.size, file.name)}}</div>
                                        </div>
                                        <z-icon @click="removeFile(item.id, file.name)" name="close" width="24" height="24"></z-icon>
                                    </div>
                                </div>
                            </div>
                            <div class="col-default-12 u-top-margin-one">
                                <p class="claims__dull u-collapse--bottom"><small v-html="text.format"></small></p>
                                <p class="claims__dull u-collapse--bottom"><small v-html="text.size"></small></p>
                            </div>
                            <div
                                class="col-default-12 files-error"
                                v-show="fileFormatError"
                            >
                                <span class="files-error__msg">
                                    {{ text.error.fileFormat }}
                                </span>
                            </div>
                            <div
                                class="col-default-12 files-error"
                                v-show="isFilesMaxSizeReached"
                            >
                                <span class="files-error__msg">
                                    {{ text.error.fileSize }}. Текущий размер файлов ({{ this.getFileSizeStr(this.totalFilesSize) }})
                                </span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-default-12">
                                <div class="form__item">
                                    <z-checkbox
                                        name="agreement"
                                        ref="agreement"
                                        required
                                        v-model="agreement"
                                    ><small class="claims__dull" v-html="text.agreement"></small>
                                    </z-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-default-12">
                                <div class="claims__contacts">
                                    <p v-html="text.contacts"></p>
                                    <p class="claims__contacts--text">
                                        <span>
                                            <z-link href="tel:+74999578659">
                                                <z-icon name="phone" height="24" width="24"></z-icon>+7 (499) 957-86-59
                                            </z-link>
                                        </span>
                                        <span>
                                            <z-link href="mailto:claim@tcmstrade.ru">
                                                <z-icon name="email" height="24" width="24"></z-icon>claim@tcmstrade.ru
                                            </z-link>
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-default-12">
                                <div class="claims__btn-row">
                                    <z-button class="claims__btn-submit" type="submit">{{text.submit}}</z-button>
                                    <z-button
                                        size="s"
                                        kind="close"
                                        @click="clearForm"
                                        v-if="isClearBtnShown"
                                    >
                                        {{ text.reset }}
                                    </z-button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div
                v-else
                class="preloader"
            >
                <span class="preloader__inner"></span>
            </div>
        </div>
        <popup-message
            type="form"
            @close="hideMessage"
            :text="message.text"
            :show="message.show"
            :state="message.state"
        />
    </div>
</template>
<script>
import { localize } from '@/utils/i18n'
import { gRecaptcha } from '@/utils/mixin'
import { debounce } from 'throttle-debounce'
import PopupMessage from './PopupMessage.vue'

export default {
    name: 'claims',
    mixins: [gRecaptcha],
    props: {
        data: Object
    },
    components: {
        PopupMessage
    },
    data () {
        return {
            maxFilesSize: 128,
            totalFilesSize: 0,
            agreement: false,
            handlerSend: `/${this.$root.lang}/api/claims-form-send/`,
            loading: false,
            params: {
                companies: {
                    value: '',
                    placeholder: localize({
                        'ru': 'Наименование Вашей организации *',
                        'en': 'Name companies *'
                    })
                },
                user: {
                    value: '',
                    placeholder: localize({
                        'ru': 'Контактное лицо *',
                        'en': 'User name *'
                    })
                },
                email: {
                    value: '',
                    placeholder: localize({
                        'ru': 'Контактный E-mail *',
                        'en': 'E-mail *'
                    })
                },
                phone: {
                    value: '',
                    placeholder: localize({
                        'ru': 'Контактный телефон *',
                        'en': 'Phone number *'
                    })
                },
                product: {
                    value: '',
                    placeholder: localize({
                        'ru': 'Товар *',
                        'en': 'Product *'
                    })
                },
                volume: {
                    value: '',
                    placeholder: localize({
                        'ru': 'Объем шт/тн *',
                        'en': 'Volume pcs/tn *'
                    })
                },
                transport: {
                    value: '',
                    placeholder: localize({
                        'ru': 'Номер транспортной накладной *',
                        'en': 'Bill of lading number *'
                    })
                },
                type: {
                    value: '',
                    placeholder: localize({
                        'ru': 'Тип обращения *',
                        'en': 'Type of application *'
                    })
                },
                managers: {
                    value: '',
                    placeholder: localize({
                        'ru': 'Отправить менеджеру *',
                        'en': 'Send to manager *'
                    })
                },
                text: {
                    value: '',
                    placeholder: localize({
                        'ru': 'Сообщение',
                        'en': 'Message'
                    })
                }
            },
            enumParams: {
                'companies': 'claimsFormCompanies',
                'user': 'claimsFormUser',
                'email': 'claimsFormEmail',
                'phone': 'claimsFormPhone',
                'product': 'claimsFormProduct',
                'volume': 'claimsFormVolume',
                'transport': 'claimsFormTransport',
                'type': 'claimsFormType',
                'managers': 'claimsFormManager',
                'text': 'claimsFormText'
            },
            fileForm: [
                {
                    name: 'Претензионное письмо:',
                    id: 'claimsFormFileClaims'
                },
                {
                    name: 'Акт:',
                    id: 'claimsFormFileAct'
                },
                {
                    name: 'Сертификат:',
                    id: 'claimsFormFileCertificate'
                },
                {
                    name: 'Фото (бирок, дефекта, пачки):',
                    id: 'claimsFormFilePhoto'
                },
                {
                    name: 'Свидетельство о&nbsp;проверке весов:',
                    id: 'claimsFormFileVerificationOfWeights'
                },
                {
                    name: 'Расчёт суммы претензии:',
                    id: 'claimsFormFileAmountCalculation'
                },
                {
                    name: 'Дополнительный файл:',
                    id: 'claimsFormFileAdditional'
                }
            ],
            files: {
                claimsFormFileClaims: [],
                claimsFormFileAct: [],
                claimsFormFileCertificate: [],
                claimsFormFilePhoto: [],
                claimsFormFileVerificationOfWeights: [],
                claimsFormFileAmountCalculation: [],
                claimsFormFileAdditional: []
            },
            acceptFiles: ['.doc', '.docx', '.pdf', '.txt', 'image/png', 'image/jpg', 'image/jpeg'],
            validateFormatArr: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'text/plain', 'image/png', 'image/jpg', 'image/jpeg'],
            fileFormatError: false,
            showError: {
                claimsFormFileClaims: false,
                claimsFormFileAct: false,
                claimsFormFileCertificate: false,
                claimsFormFilePhoto: false
            },
            text: {
                success: localize({
                    'ru': 'Отправка данных прошла успешно, спасибо за Ваше сообщение!',
                    'en': 'Sending data was successful, thanks for your message!'
                }),
                error: {
                    error: localize({
                        'ru': 'Ошибка отправки',
                        'en': 'Sending error'
                    }),
                    server: localize({
                        'ru': 'Ошибка сервера',
                        'en': 'Sending server error'
                    }),
                    required: localize({
                        'ru': 'Ошибка валидации',
                        'en': 'Sending validation error'
                    }),
                    captcha: localize({
                        'ru': 'Ошибка каптчи',
                        'en': 'Sending captcha error'
                    }),
                    file: localize({
                        'ru': 'Ошибка, поле прикрепить файл должно быть заполнено',
                        'en': 'Sending file error'
                    }),
                    fileSize: localize({
                        'ru': 'Превышен максимальный размер файлов',
                        'en': 'Filesize exceeded'
                    }),
                    fileFormat: localize({
                        'ru': 'Неверный формат файла',
                        'en': 'Invalid file format'
                    })
                },
                lead: localize({
                    'ru': 'ООО &laquo;ТК&nbsp;МС-Трейд&raquo; уделяет особое внимание работе с&nbsp;клиентами и&nbsp;повышению качества реализуемой продукции. С&nbsp;целью оперативного решения Ваших запросов просим Вас предоставлять максимально исчерпывающую и&nbsp;корректную информацию. Это позволит повысить оперативность рассмотрения Ваших обращений и&nbsp;претензий.',
                    'en': 'ООО &laquo;ТК&nbsp;МС-Трейд&raquo; уделяет особое внимание работе с&nbsp;клиентами и&nbsp;повышению качества реализуемой продукции. С&nbsp;целью оперативного решения Ваших запросов просим Вас предоставлять максимально исчерпывающую и&nbsp;корректную информацию. Это позволит повысить оперативность рассмотрения Ваших обращений и&nbsp;претензий.'
                }),
                size: localize({
                    'ru': '* Максимальный суммарный размер файлов не&nbsp;более 128 Мбайт',
                    'en': '* Total files size must be less than 128 MiB'
                }),
                format: localize({
                    'ru': '* Допустимые форматы файлов: doc, docx, pdf, txt, png, jpg, jpeg',
                    'en': '* Acceptable file formats: doc, docx, pdf, txt, png, jpg, jpeg'
                }),
                file: localize({
                    'ru': 'Прикрепить файл&nbsp;*',
                    'en': 'Прикрепить файл&nbsp;*'
                }),
                fileNone: localize({
                    'ru': 'Прикрепить файл',
                    'en': 'Прикрепить файл'
                }),
                required: localize({
                    'ru': 'Поле обязательно для заполнения',
                    'en': 'Поле обязательно для заполнения'
                }),
                agreement: localize({
                    'ru': `Я ознакомился с&nbsp;<a href="/files/ru/privacy-policy-ru.pdf" target="_blank" class="link">Политикой о&nbsp;защите персональных данных</a> и&nbsp;даю согласие на&nbsp;обработку моих персональных данных&nbsp;*`,
                    'en': `Я ознакомился с <a href="/files/en/privacy-policy-en.pdf" target="_blank" class="link">Политикой о защите персональных данных</a> и даю согласие на обработку моих персональных данных&nbsp;*`
                }),
                contacts: localize({
                    'ru': 'Контактные данные дирекции по&nbsp;претензионной работе:',
                    'en': 'Контактные данные дирекции по претензионной работе:'
                }),
                submit: localize({
                    'ru': 'Отправить',
                    'en': 'Отправить'
                }),
                reset: localize({
                    'ru': 'Сбросить все',
                    'en': 'Сбросить все'
                }),
                byte: localize({
                    'ru': 'Б',
                    'en': 'B'
                }),
                kib: localize({
                    'ru': 'Кбайт',
                    'en': 'KiB'
                }),
                mib: localize({
                    'ru': 'Мбайт',
                    'en': 'MiB'
                })

            },
            message: {
                text: '',
                state: '',
                show: false
            }
        }
    },
    computed: {
        filters () {
            return {
                type: {
                    options: this.data.types.map(function (item) {
                        return {
                            'id': item.name,
                            'selected': false,
                            'disabled': false,
                            'text': item.name
                        }
                    })
                },
                managers: {
                    options: this.data.items.map(function (item) {
                        return {
                            'id': item.mail,
                            'selected': false,
                            'disabled': false,
                            'text': item.name
                        }
                    })
                }
            }
        },
        isClearBtnShown () {
            let result = false

            if (this.agreement) result = true

            for (let key in this.params) {
                if (this.enumParams.hasOwnProperty(key)) {
                    if (this.params[key].value.length) {
                        result = true
                        break
                    }
                }
            }

            for (let key in this.files) {
                if (this.files[key].length) {
                    result = true
                    break
                }
            }

            return result
        },
        isFilesMaxSizeReached () {
            return (this.totalFilesSize / 1024 / 1024) >= this.maxFilesSize
        }
    },
    methods: {
        valid () {
            let isValid = true
            for (let key in this.showError) {
                if (!this.files[key].length && !this.showError[key]) {
                    this.showError[key] = true
                    isValid = false
                }
            }

            this.$refs.companies.validate()
            this.$refs.user.validate()
            this.$refs.email.validate()
            this.$refs.phone.validate()
            this.$refs.product.validate()
            this.$refs.volume.validate()
            this.$refs.transport.validate()
            this.$refs.agreement.validate()

            const valid = !this.$refs.companies.error &&
                !this.$refs.user.error &&
                !this.$refs.agreement.error &&
                !this.$refs.email.error &&
                !this.$refs.phone.error &&
                !this.$refs.product.error &&
                !this.$refs.volume.error &&
                !this.$refs.transport.error &&
                !this.isFilesMaxSizeReached

            if (this.data.types.length && valid) {
                this.$refs.typeSelect.validate()
                const valid = !this.$refs.typeSelect.error
            }

            if (this.data.items.length && valid) {
                this.$refs.managersSelect.validate()
                const valid = !this.$refs.managersSelect.error
            }

            return valid && isValid
        },
        buildName (name) {
            return name.replace(/\.[^/.]+$/, '')
        },
        getFileSizeStr (size) {
            let fileSizeString

            if (size < 1024) {
                fileSizeString = `${size} ${this.text.byte}`
            } else if ((size /= 1024) < 1024) {
                fileSizeString = `${size.toFixed(2)} ${this.text.kib}`
            } else if ((size /= 1024) < 1024) {
                fileSizeString = `${size.toFixed(2)} ${this.text.mib}`
            }

            return fileSizeString
        },
        getFileNameStr (name) {
            let fileNameString = name.split('.').pop()
            return fileNameString
        },
        getFileDesc (size, name) {
            return `(${this.getFileSizeStr(size)}, ${this.getFileNameStr(name)})`
        },
        removeFile (id, name) {
            this.totalFilesSize -= this.files[id][0].size

            this.files[id] = this.files[id].filter(el => {
                return el.name !== name
            })

            if (this.$refs[`fileInput${id}`] && this.$refs[`fileInput${id}`].length) {
                this.$refs[`fileInput${id}`][0].value = null
            }

            if (!this.files[id].length && this.showError[id]) {
                this.showError[id] = true
            }
        },
        createFile (e, id) {
            if (e.target.value.length) {
                this.fileFormatError = false

                Array.from(e.target.files).forEach((el) => {
                    if (this.validateFormatArr.includes(el.type)) {
                        const isExist = this.files[id].some(item => item.name === el.name)
                        if (isExist) return

                        this.files[id].push(el)
                        this.totalFilesSize += el.size
                    } else {
                        this.fileFormatError = true
                    }
                })
                if (this.showError[id]) {
                    this.showError[id] = false
                }
            } else {
                if (!this.files[id].length) {
                    this.showError[id] = true
                }
            }
        },
        submit () {
            this.send(this, this.params)
        },
        clearForm () {
            this.$root.$bus.$emit('clear', 'managersSelect')
            this.$root.$bus.$emit('clear', 'typeSelect')

            if (this.$refs.agreement) this.$refs.agreement.clear()

            for (let key in this.params) {
                this.params[key].value = ''
            }
            for (let key in this.files) {
                this.files[key].forEach(item => {
                    this.removeFile(key, item.name)
                })
            }
        },
        showMessage (text, state) {
            this.message.show = true
            this.message.text = text
            this.message.state = state
            document.body.style.overflow = 'hidden'
        },
        hideMessage () {
            this.message.show = false
            document.body.style.overflow = ''
        },
        send: debounce(500, function (_this, params) {
            if (!this.valid()) return

            grecaptcha.ready(function () {
                grecaptcha
                    .execute('6LfyS74iAAAAAATZNMqmPUAnY1CZ2pXchfzpmZID', {
                        action: 'claimsFormCaptcha'
                    })
                    .then(function (token) {
                        _this.loading = true
                        params.claimsFormCaptcha = token

                        let formData = _this.buildFormData(params)

                        fetch(_this.handlerSend, {
                            method: 'POST',
                            body: formData
                        }).then(response => {
                            if (response.status >= 200 && response.status < 300) {
                                return response
                            } else {
                                let error = new Error(response.statusText)
                                error.response = response
                                throw error
                            }
                        }).then(response => response.json()).then(data => {
                            let state
                            let text

                            if (data.status === 'error') {
                                state = 'error'
                                switch (data.type) {
                                case 'server':
                                    text = _this.text.error.server
                                    break
                                case 'required':
                                    text = _this.text.error.required
                                    break
                                case 'captcha':
                                    text = _this.text.error.captcha
                                    break
                                case 'file':
                                    text = _this.text.error.file
                                    break
                                case false:
                                    text = data.text ? data.text : _this.text.error.fileSize
                                    break
                                default:
                                    text = _this.text.error.error
                                    break
                                }
                            } else {
                                state = 'success'
                                text = _this.text.success
                                delete _this.params.claimsFormCaptcha
                                _this.clearForm()
                            }

                            _this.showMessage(text, state)
                            _this.loading = false
                        }).catch(error => {
                            console.log(error)
                            _this.error = error
                            _this.showMessage(error.message, 'error')
                            _this.loading = false
                        })
                    }, function (reason) {
                        _this.showMessage(reason, 'error')
                        _this.loading = false
                    })
            })
        }),
        buildFormData (params) {
            let data = new FormData()

            for (let key in params) {
                if (this.enumParams.hasOwnProperty(key)) {
                    if (params[key].value.length) {
                        data.append(this.enumParams[key], params[key].value)
                    }
                } else {
                    data.append(key, params[key])
                }
            }

            for (let key in this.files) {
                if (this.files[key].length) {
                    this.files[key].forEach(file => {
                        data.append(`${key}[]`, file)
                    })
                }
            }

            data.append('claimsFormAgreement', this.agreement)

            return data
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
